<template>
  <div class="leco-content">
    <div class="page-title">Eメールアドレス確認</div>
    <div v-if="mainLoading" class="loader">loading...</div>
    <div v-else>
      <div>
        {{ this.email }} のEメールアドレスが確認できました。<br />
        ログインページに移動し、利用を開始してください。
      </div>
      <button
        class="btn btn-outline-secondary move-login-btn"
        @click="move_login"
      >
        ログインページへ
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/common/config";
export default {
  name: "email-confirm",

  data() {
    return {
      mainLoading: false,
      logger: this.$store.state.logger,
      email: ""
    };
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.mainLoading = true;
    //アクセスログを取得
    this.logger.info("Eメールと確認コードのチェックを開始");

    var err = null;

    var clientId = this.$route.query.client_id;
    var userName = this.$route.query.user_name;
    this.email = this.$route.query.user_name;
    var confirmationCode = this.$route.query.confirmation_code;

    if (clientId == null) err += "client_id param is required.";
    if (userName == null) err += "user_name param is required.";
    if (confirmationCode == null) err += "confirmation_code param is required.";

    if (err) {
      this.mainLoading = false;
      this.logger.error("クエリパラメタの読み込みに失敗");
      this.logger.error(err);
      this.$router.push("/system-error500");
    }

    // CognitoにEメールと確認コードで検証を行う
    let api_url =
      API_BASE_URL +
      "email-confirm?client_id=" +
      clientId +
      "&user_name=" +
      userName +
      "&confirmation_code=" +
      confirmationCode;
    axios
      .get(api_url)
      .then((response) => {
        //statusCode==200以外は全部500のエラー画面に飛ばす
        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.logger.info("Eメールと確認コードをチェック完了");
            this.logger.debug(JSON.stringify(response.data));
          } else {
            this.logger.error(
              "Eメールと確認コードをチェックでstatusCode=200以外が返されました。statusCode=" +
                response.data.statusCode
            );
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error(
            "Eメールと確認コードをチェックでstatusCodeが返されませんでした。" +
              response
          );
          this.$router.push("/system-error500");
        }
        this.mainLoading = false;
      })
      .catch((error) => {
        this.mainLoading = false;
        this.logger.error("Eメールと確認コードのチェックに失敗");
        this.logger.error(error);
        this.$router.push("/system-error500");
      });
  },
  methods: {
    //更新ボタンクリック時に実行される処理
    move_login: function () {
      this.logger.debug("ログインページに移動します。");
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.move-login-btn {
  width: 300px;
  margin-top: 25px;
}
/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
